import { render, staticRenderFns } from "./additional-activities-legend.vue?vue&type=template&id=896900e6"
import script from "./additional-activities-legend.vue?vue&type=script&lang=js"
export * from "./additional-activities-legend.vue?vue&type=script&lang=js"
import style0 from "./additional-activities-legend.vue?vue&type=style&index=0&id=896900e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports